// extracted by mini-css-extract-plugin
export var commentLink = "_4e-0";
export var commentProfile = "_4e-1";